import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { DatevAccount, IDatevAccount } from "@/models/datev-account.entity";
import datevAccountService from "@/services/mrfiktiv/services/datev-account-service";
import { MrfiktivPartnerDatevAccountControllerFindAllByPartnerIdParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const DatevAccountPageDataProvider = new (class extends AbstractPageDataProvider<
  IDatevAccount,
  MrfiktivPartnerDatevAccountControllerFindAllByPartnerIdParamsGen
> {
  itemsPerPage = 25;

  async getPage(
    query: MrfiktivPartnerDatevAccountControllerFindAllByPartnerIdParamsGen
  ): Promise<IPageViewModel<IDatevAccount>> {
    const res = await datevAccountService.get(query);

    const meta = res.meta;
    const data = (res.data?.map((a) => new DatevAccount(a)) ?? []) as IDatevAccount[];

    return { meta, data };
  }
})();
